import React from 'react';
import styles from '../Dana/styles.css';

const English = () => {
  return (
    <div className={styles['tnc-wrapper']}>
      <h5>LIST OF PROHIBITED ITEMS AND/OR CONTENT</h5>
      <ol type="I">
        <li>
          <strong>Contain negative content</strong>
          <ol type="i">
            <li>
              Pornography
              <ol type="a">
                <li>
                  Pornographic images, sketches, illustrations, photographs,
                  text, voice, sound, video, animations, cartoons,
                  conversations, gestures, or other forms of messages that
                  contain obscenity or sexual exploitation that violate the
                  norms of decency in society
                </li>
                <li>Pornography services</li>
              </ol>
            </li>
            <li>
              Adult items supporting sexual activity, including but not limited
              to:
              <ol type="a">
                <li>Strong medicine</li>
                <li>Stimulants</li>
                <li>Sex toys</li>
                <li>
                  Adult medicines, except for medical devices (contraception)
                  which are permitted to be traded by the applicable legal
                  regulations in Indonesia
                </li>
              </ol>
            </li>
            <li>
              Goods and/or services contain content gambling, the lottery,
              and/or wager
            </li>
            <li>Goods and/or services that contain hate content</li>
            <li>
              Goods and/or services that contain content that violates
              intellectual property rights:
              <ol type="a">
                <li>
                  Pirated goods (goods which are the result of illegal
                  copies/copying for commercial purposes)
                </li>
                <li>
                  Counterfeit goods (goods that are produced and/or traded as
                  imitations, replicas, or imitations of other goods or goods
                  that use the same brand in its entirety with other parties
                  registered marks)
                </li>
              </ol>
            </li>
            <li>
              Goods and/or services that contain hacking content and/or provide
              access without rights or against electronic systems
            </li>
            <li>
              Goods and/or services that contain content and/or provide access
              to drugs, addictive substances, and psychotropic substances
            </li>
            <li>
              Goods and/or services that contain content with material
              dishonesty, deceiving or misleading others. (For example, mystical
              or superstitious things (amulets, objects claimed to have
              supernatural powers and supernatural powers), fraud, money
              laundering services, document forgery services (diplomas,
              certificates, doctor's letters, receipts, etc.))
            </li>
            <li>
              Goods and/or services that contain content of human trafficking
              (human remains) and/or parts of human organs
            </li>
          </ol>
        </li>
        <li>
          <strong>
            Do not have permission to trade in accordance with statutory
            provisions
          </strong>
          <ol type="i">
            <li>
              Goods and/or services related to weapons, military and explosives
              (Example: Firearms, air weapons, ammunition, stun guns, rifles,
              firearms equipment, replicas of firearms, airsoft guns, air guns,
              and bullet or some kind ofbullet, explosives, sharp weapons, and
              other types of weapons. Includes items relating to government or
              state institutions such as badges, ranks or uniforms)
            </li>
            <li>
              Goods and/or services that trade in protected plants and/or
              animals
            </li>
            <li>
              Goods and/or services that contain content about tools and/or
              devices that are prohibited and/or that are not determined by the
              ministry/agency
            </li>
            <li>
              Goods and/or services that contain content about toxic and
              hazardous chemicals (substances classified as hazardous chemicals
              according to the applicable Minister of Trade Regulation)
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
};

export default English;
